import React from 'react';
import PropTypes from 'prop-types';

import './HelpTile.scss';

const HelpTileComponent = ({ children }) => (
  <section className="help-tile">
    <section className="help-tile__content">{children}</section>
  </section>
);

HelpTileComponent.propTypes = {
  children: PropTypes.node.isRequired,
};

export default HelpTileComponent;
